import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
} from "@mui/material";

import img6 from "../../pictures/img6.jpg";
import team1 from "../../pictures/img1.jpg";
import team2 from "../../pictures/img10.jpg";
import team3 from "../../pictures/img11.jpg";

function OurTeam() {
  const team = [
    {
      name: "Mr. V. Thamaraiselvan",
      role: "Structural Engineer",
      experience: "20+ Years Experience",
      image: team1,
      accent: "#4f6dff",
    },
    {
      name: "Mr. V. Yuvaraj",
      role: "Project Manager",
      experience: "15+ Years Experience",
      image: team2,
      accent: "#7b5cff",
    },
    {
      name: "Mr. Pandian",
      role: "Executive Engineer",
      experience: "30+ Years Experience",
      image: team3,
      accent: "#00a6c7",
    },
  ];

  return (
    <Box sx={{ background: "linear-gradient(180deg, #f5f7ff 0%, #eef2ff 100%)" }}>
      {/* HERO SECTION */}
      <Box
        sx={{
          position: "relative",
          minHeight: { xs: "42vh", md: "58vh" },
          backgroundImage: `linear-gradient(rgba(8,10,40,0.58), rgba(11,8,80,0.72)), url(${img6})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          textAlign: "center",
          overflow: "hidden",
        }}
      >
        {/* 3D floating background orbs */}
        <Box
          sx={{
            position: "absolute",
            width: 220,
            height: 220,
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(255,255,255,0.22), rgba(255,255,255,0.02))",
            top: "12%",
            left: "8%",
            filter: "blur(6px)",
            animation: "floatOrb 8s ease-in-out infinite",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: 180,
            height: 180,
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(79,109,255,0.30), rgba(79,109,255,0.04))",
            bottom: "10%",
            right: "10%",
            filter: "blur(8px)",
            animation: "floatOrb 10s ease-in-out infinite 1.2s",
          }}
        />

        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            px: 3,
            py: 4,
            borderRadius: 4,
            background: "rgba(255,255,255,0.10)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(255,255,255,0.16)",
            boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
            animation: "heroFloat 6s ease-in-out infinite",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "2.2rem", md: "3.4rem" },
              fontWeight: 800,
              letterSpacing: "-0.02em",
              mb: 1,
            }}
          >
            Our Team
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1rem", md: "1.15rem" },
              color: "rgba(255,255,255,0.88)",
              maxWidth: 620,
              mx: "auto",
            }}
          >
            Meet the experts behind our successful projects, engineering strength,
            and trusted execution.
          </Typography>
        </Box>
      </Box>

      {/* TEAM SECTION */}
      <Container sx={{ py: { xs: 8, md: 12 } }}>
        <Typography
          variant="h4"
          textAlign="center"
          fontWeight="bold"
          gutterBottom
          sx={{ color: "#100e62", mb: 2 }}
        >
          Our Expert Team
        </Typography>

        <Typography
          textAlign="center"
          sx={{
            color: "#5b6275",
            maxWidth: 720,
            mx: "auto",
            mb: 7,
            lineHeight: 1.8,
          }}
        >
          A dedicated team of professionals bringing together technical knowledge,
          project leadership, and decades of field experience.
        </Typography>

        <Grid container spacing={5} justifyContent="center">
          {team.map((member, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  perspective: "1400px",
                  height: "100%",
                }}
              >
                <Card
                  sx={{
                    position: "relative",
                    overflow: "visible",
                    textAlign: "center",
                    borderRadius: 5,
                    p: 2,
                    pt: 7,
                    minHeight: 360,
                    background: "rgba(255,255,255,0.72)",
                    backdropFilter: "blur(16px)",
                    border: "1px solid rgba(16,14,98,0.08)",
                    boxShadow: "0 24px 55px rgba(17, 17, 35, 0.12)",
                    transformStyle: "preserve-3d",
                    transform:
                      index % 2 === 0
                        ? "rotateY(-8deg) rotateX(5deg)"
                        : "rotateY(8deg) rotateX(5deg)",
                    transition: "transform 0.45s ease, box-shadow 0.45s ease",
                    animation: `teamCardFloat 6s ease-in-out ${index * 0.3}s infinite`,
                    "&:hover": {
                      transform: "rotateY(0deg) rotateX(0deg) translateY(-12px) scale(1.03)",
                      boxShadow: "0 30px 70px rgba(17,17,35,0.18)",
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      inset: 0,
                      borderRadius: "20px",
                      background: `linear-gradient(145deg, ${member.accent}22, rgba(255,255,255,0.12))`,
                      transform: "translateZ(-20px) translateY(10px)",
                      zIndex: 0,
                    },
                  }}
                >
                  <Avatar
                    // src={member.image}
                    // alt={member.name}
                    sx={{
                      width: 110,
                      height: 110,
                      position: "absolute",
                      top: -55,
                      left: "50%",
                      transform: "translateX(-50%) translateZ(40px)",
                      border: "5px solid #fff",
                      boxShadow: "0 18px 35px rgba(0,0,0,0.18)",
                      backgroundColor: "#100e62",
                    }}
                  />

                  <CardContent sx={{ position: "relative", zIndex: 2 }}>
                    <Box
                      sx={{
                        width: 56,
                        height: 5,
                        borderRadius: 999,
                        background: `linear-gradient(90deg, ${member.accent}, #100e62)`,
                        mx: "auto",
                        mb: 2,
                      }}
                    />

                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        color: "#16163f",
                        mb: 1,
                        minHeight: 58,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {member.name}
                    </Typography>

                    <Typography
                      sx={{
                        color: member.accent,
                        fontWeight: 700,
                        mb: 1,
                        letterSpacing: "0.02em",
                      }}
                    >
                      {member.role}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#5f6478",
                        fontSize: "0.98rem",
                        lineHeight: 1.8,
                      }}
                    >
                      {member.experience}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      <style>{`
        @keyframes heroFloat {
          0%, 100% {
            transform: translateY(0px) rotateX(0deg);
          }
          50% {
            transform: translateY(-10px) rotateX(2deg);
          }
        }

        @keyframes floatOrb {
          0%, 100% {
            transform: translateY(0px) translateX(0px) scale(1);
          }
          50% {
            transform: translateY(-18px) translateX(10px) scale(1.06);
          }
        }

        @keyframes teamCardFloat {
          0%, 100% {
            transform: translateY(0px) rotateX(5deg);
          }
          50% {
            transform: translateY(-14px) rotateX(2deg);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          *, *::before, *::after {
            animation: none !important;
            transition: none !important;
          }
        }
      `}</style>
    </Box>
  );
}

export default OurTeam;